import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import _ from "lodash";

const MyButton = styled.button`
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.5s;

  ${props =>
    props.type === "default" &&
    css`
      background-color: #04a8a6;
      font-size: 11px;
      letter-spacing: 2px;
      line-height: 35px;
      color: #ffffff;
      padding: 0 25px;
      &:hover {
        ${props.hoverStyle};
      }
    `}

  ${props =>
    props.type === "primary" &&
    css`
      background-color: transparent;
      font-size: 11px;
      letter-spacing: 2px;
      line-height: 28px;
      color: #ffffff;
      border: 1px solid #ffffff;
      padding: 2px 20px;
      &:hover {
        ${props.hoverStyle};
      }
    `}

  ${props =>
    props.type === "secondary" &&
    css`
      background-color: #3d3e3d;
      font-size: 15px;
      color: #ffffff;
      padding: 10px 15px;
      font-weight: bold;
      &:hover {
        ${props.hoverStyle};
      }
      /* @media (max-width: 1290px) {
        ${props.page === "residence" ? "font-size: 5px" : ""}
      }
      @media (max-width: 1000px) {
        ${props.page === "residence" ? "padding: 0px" : ""}
      } */
    `}

  ${props =>
    props.type === "groupVerticle" &&
    css`
      color: #000;
      text-transform: uppercase;
      display: block;
      text-align: left;
      font-size: 11px;
      background-color: #dbdbdb;
      padding: 2px 5px 2px 0;
      font-family: "MS Sans Serif", Helvetica, sans-serif;
      line-height: 30px;
      font-weight: bold;
      width: 100%;
      margin-right: 10px;
      margin-left: 0;
      margin-bottom: 3px;
      transform: color 0.5s, background-color 0.5s;
      display: flex;
      align-items: center;
      &:hover {
        background-color: white;
      }
    `}

  ${props => props.defaultStyle}

  ${props => (props.isActive === true ? props.activeStyle : {})}

`;

class Button extends Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    active: PropTypes.bool,
    activeStyle: PropTypes.shape(),
    hoverStyle: PropTypes.shape(),
    defaultStyle: PropTypes.shape(),
    page: PropTypes.string
  };
  static defaultProps = {
    className: "",
    type: "default",
    active: false,
    activeStyle: {},
    hoverStyle: {},
    defaultStyle: {},
    page: ""
  };
  shouldComponentUpdate(nextProps) {
    const fieldToCheck = [
      "active",
      "activeStyle",
      "children",
      "defaultStyle",
      "hoverStyle",
      "page",
      "type"
    ];
    const _nextProps = _.pick(nextProps, fieldToCheck);
    const _thisProps = _.pick(this.props, fieldToCheck);
    return !_.isEqual(_nextProps, _thisProps);
  }
  // state = {
  //   isActive: this.props.active
  // };
  // handleClickButton = () => {
  //   // const { isActive } = this.state;
  //   this.setState({ isActive: true });
  // };
  render() {
    const {
      className,
      type,
      activeStyle,
      hoverStyle,
      defaultStyle,
      active,
      onClick,
      page
    } = this.props;
    // const { isActive } = this.state;
    return (
      <MyButton
        className={className}
        page={page}
        type={type}
        isActive={active}
        hoverStyle={hoverStyle}
        activeStyle={activeStyle}
        defaultStyle={defaultStyle}
        onClick={onClick}
        // onClick={this.handleClickButton}
      >
        {this.props.children}
      </MyButton>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js